// extracted by mini-css-extract-plugin
module.exports = {"image":"Home_image__3DuFa","container":"Home_container__1ukFy","text":"Home_text__23g9D"};